import { createI18n } from 'vue-i18n'

import esLocale from './locale/es'
import enLocale from './locale/en'

const messages = {
  es: esLocale,
  en: enLocale,
}

const i18n = new createI18n({
  locale: 'es',
  allowComposition: true,
  fallbackLocale: 'es',
  messages,
})

export default i18n
